const INITIAL_STATE = {
  materialsFamilyList: []
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SET_MATERIALS_FAMILY': {
      return { ...state, materialsFamilyList: action.materialsFamily };
    }
    default:
      return state;
  }
};
